
export const text = `

Argh-- careful with the nuzzling, Devy, you’re heavy! Bplth-- you’re going to make me eat your feathers! Ack--! Okay, Devy! Down! Not my hair! Yeah. Yeah, thank you.

I know you care, Devy-- you let me know stuff all the time, so don’t worry about it, alright? I’m fine. And I’m sorry it’s been hard, ever since… yeah. Listen, we’ll get that d-hole, alright? We’ll make him pay. You’re safe here. Make yourself comfortable, okay?

[THERE’S SOME COOING BEFORE THE SOUND OF SOMETHING SCRUNCHING OFF GOES OFF. THE MONSTER’S RUMBLING OVER THE MIC IS APPARENT AS IT DOZES OFF.]

`